import identity from 'transmute/identity';
import { fetchLeadFollowUpHiddenSettings } from '../../input/leads/leadFollowUpHiddenSettingsApi';
import { InMemoryCache } from '../InMemoryCache';
export const makeLeadFollowUpSettingsCache = () => new InMemoryCache('LeadFollowUpSettingsCache', fetchLeadFollowUpHiddenSettings, identity);